import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VolcanoMap = _resolveComponent("VolcanoMap")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_VolcanoCharts = _resolveComponent("VolcanoCharts")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_VolcanoMap, { volcanoes: _ctx.volcanoes }, null, 8, ["volcanoes"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_VolcanoCharts, { volcanoes: _ctx.volcanoes }, null, 8, ["volcanoes"]),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "火山监测列表",
              bordered: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: _ctx.columns,
                  "data-source": _ctx.volcanoes,
                  loading: _ctx.loading,
                  rowKey: "id"
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'alertLevel')
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: _ctx.getAlertLevelColor(record.status?.alertLevel)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.status?.alertLevel), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      : _createCommentVNode("", true),
                    (column.key === 'aviationCode')
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: _ctx.getAviationCodeColor(record.status?.aviationColorCode)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.status?.aviationColorCode), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      : _createCommentVNode("", true),
                    (column.key === 'action')
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          type: "link",
                          onClick: ($event: any) => (_ctx.showHistory(record))
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("查看历史")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.historyModalVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.historyModalVisible) = $event)),
      title: "火山状态历史记录",
      width: "800px",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_timeline, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedVolcanoHistory, (status) => {
              return (_openBlock(), _createBlock(_component_a_timeline_item, {
                key: status.id,
                color: _ctx.getTimelineColor(status.alertLevel)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTime(status.statusTime)), 1),
                  _createElementVNode("p", null, "警戒级别: " + _toDisplayString(status.alertLevel), 1),
                  _createElementVNode("p", null, "航空代码: " + _toDisplayString(status.aviationColorCode), 1),
                  _createElementVNode("p", null, _toDisplayString(status.statusDescription), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}